import React from 'react';
import startCase from 'lodash/startCase';
import PropTypes from 'prop-types';

import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import BlogAuthorBio from 'Components/Blog/content/BlogAuthorBio';
import CategoryTitles from 'Components/Blog/CategoryTitles';

const BlogQueryHeader = ({ authorSlug, category }) => {
  const search = getUrlParameter('search') || '';
  const tag = getUrlParameter('tag') || '';

  if (authorSlug) {
    return (
      <div className="blog-query-container p-3">
        <BlogAuthorBio isHomePage authorSlug={authorSlug} />
      </div>
    );
  }

  if (category) {
    return (
      <div className="blog-query-container">
        <div className="query-title">
          {startCase(category)}
        </div>
        {CategoryTitles[category] &&
          <p>{CategoryTitles[category].description}</p>
        }
      </div>
    );
  }

  if (search) {
    return (
      <div>
        <NoIndex />
        <div className="blog-query-container">
          <div className="query-title">
            Showing Search Results For <span className="tag-name">{`"${search}"`}</span>
          </div>
        </div>
      </div>
    );
  }

  if (tag) {
    return (
      <div>
        <NoIndex />
        <div className="blog-query-container">
          <div className="query-title">
            Showing Posts For <span className="tag-name">{`#${tag}`}</span>
          </div>
        </div>
      </div>
    );
  }

  return false;
};

BlogQueryHeader.propTypes = {
  authorSlug: PropTypes.string,
  category: PropTypes.string,
};

BlogQueryHeader.defaultProps = {
  authorSlug: '',
  category: '',
};

export default BlogQueryHeader;
